/* GAU HOME — behaviour for the custom homepage sections.
   Plain JS, no dependencies. Click/change handling is delegated on document so it
   keeps working after the theme editor re-renders a section. */
(function () {
  if (window.__gauHomeLoaded) return;
  window.__gauHomeLoaded = true;

  var heroTimers = new WeakMap();

  /* ---------- Sliders (product rows, videos, testimonials, blog) ---------- */
  function updateSlider(slider) {
    var track = slider.querySelector('[data-gau-track]');
    if (!track) return;
    var can = track.scrollWidth - track.clientWidth > 4;
    slider.setAttribute('data-can-scroll', can ? 'true' : 'false');
    slider.setAttribute('data-at-start', track.scrollLeft <= 4 ? 'true' : 'false');
    slider.setAttribute('data-at-end', track.scrollLeft >= track.scrollWidth - track.clientWidth - 4 ? 'true' : 'false');
  }

  function bindSlider(slider) {
    if (slider.__gauBound) { updateSlider(slider); return; }
    slider.__gauBound = true;
    var track = slider.querySelector('[data-gau-track]');
    if (!track) return;
    track.addEventListener('scroll', function () { updateSlider(slider); }, { passive: true });
    window.addEventListener('resize', function () { updateSlider(slider); });
    updateSlider(slider);
  }

  function scrollTrack(track, dir) {
    var first = track.firstElementChild;
    if (!first) return;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    track.scrollBy({ left: dir * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  /* ---------- Hero ---------- */
  function heroIndex(hero) {
    var track = hero.querySelector('.gau-hero__track');
    if (!track) return 0;
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }
  function heroGo(hero, i) {
    var track = hero.querySelector('.gau-hero__track');
    var n = track.children.length;
    if (!n) return;
    i = (i + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function heroSyncDots(hero) {
    var i = heroIndex(hero);
    hero.querySelectorAll('.gau-hero__dot').forEach(function (d, k) {
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }
  function bindHero(hero) {
    if (hero.__gauBound) return;
    hero.__gauBound = true;
    var track = hero.querySelector('.gau-hero__track');
    if (!track) return;
    track.addEventListener('scroll', function () { heroSyncDots(hero); }, { passive: true });
    heroSyncDots(hero);
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var delay = (parseFloat(hero.getAttribute('data-delay')) || 5) * 1000;
    if (!autoplay || track.children.length < 2) return;
    var paused = false;
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) { hero.addEventListener(e, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (e) { hero.addEventListener(e, function () { paused = false; }, { passive: true }); });
    var t = setInterval(function () {
      if (!document.body.contains(hero)) { clearInterval(t); return; }
      if (paused || document.hidden || window.Shopify && Shopify.designMode) return;
      heroGo(hero, heroIndex(hero) + 1);
    }, delay);
    heroTimers.set(hero, t);
  }

  /* ---------- Init ---------- */
  function init(root) {
    (root || document).querySelectorAll('[data-gau-slider]').forEach(bindSlider);
    (root || document).querySelectorAll('[data-gau-hero]').forEach(bindHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var arrow = t.closest('[data-gau-prev],[data-gau-next]');
    if (arrow) {
      var sl = arrow.closest('[data-gau-slider]');
      var tr = sl && sl.querySelector('[data-gau-track]');
      if (tr) scrollTrack(tr, arrow.hasAttribute('data-gau-next') ? 1 : -1);
      return;
    }

    var heroBtn = t.closest('[data-gau-hero-prev],[data-gau-hero-next],[data-gau-hero-dot]');
    if (heroBtn) {
      var hero = heroBtn.closest('[data-gau-hero]');
      if (!hero) return;
      if (heroBtn.hasAttribute('data-gau-hero-dot')) heroGo(hero, parseInt(heroBtn.getAttribute('data-gau-hero-dot'), 10));
      else heroGo(hero, heroIndex(hero) + (heroBtn.hasAttribute('data-gau-hero-next') ? 1 : -1));
      return;
    }

    var tab = t.closest('[data-gau-tab]');
    if (tab) {
      var wrap = tab.closest('[data-gau-tabs]');
      var id = tab.getAttribute('data-gau-tab');
      wrap.querySelectorAll('[data-gau-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      wrap.querySelectorAll('[data-gau-panel]').forEach(function (p) {
        var on = p.getAttribute('data-gau-panel') === id;
        p.hidden = !on;
        if (on) { var s = p.querySelector('[data-gau-slider]'); if (s) { bindSlider(s); updateSlider(s); } }
      });
      var va = wrap.querySelector('[data-gau-viewall]');
      if (va && !va.hasAttribute('data-fixed')) {
        var href = tab.getAttribute('data-gau-href');
        if (href) va.setAttribute('href', href);
      }
      return;
    }

    var qb = t.closest('[data-gau-minus],[data-gau-plus]');
    if (qb) {
      var input = qb.closest('.gau-qty').querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      v += qb.hasAttribute('data-gau-plus') ? 1 : -1;
      input.value = Math.max(1, Math.min(99, v));
      return;
    }

    var nb = t.closest('[data-gau-notify-open]');
    if (nb) {
      var box = nb.closest('[data-gau-notify]');
      var form = box.querySelector('form');
      if (form) {
        form.hidden = !form.hidden;
        if (!form.hidden) { var em = form.querySelector('input[type="email"]'); if (em) em.focus(); }
      }
      return;
    }

    var play = t.closest('[data-gau-play]');
    if (play) {
      var card = play.closest('.gau-vid');
      var vid = card.querySelector('video');
      if (vid) {
        document.querySelectorAll('.gau-vid.is-playing video').forEach(function (o) { if (o !== vid) { o.pause(); o.closest('.gau-vid').classList.remove('is-playing'); } });
        vid.muted = false; vid.controls = true; vid.play();
        card.classList.add('is-playing');
      }
      return;
    }
  });

  /* ---------- Notify me (back-in-stock request, sent through the store's contact form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.gau-notify__form');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-gau-notify]');
    var msg = box.querySelector('.gau-notify__msg');
    var btn = form.querySelector('.gau-notify__go');
    if (btn) btn.disabled = true;
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!(r.ok || r.redirected)) throw new Error('bad');
      form.hidden = true;
      var open = box.querySelector('[data-gau-notify-open]');
      if (open) open.hidden = true;
      msg.textContent = msg.getAttribute('data-done') || 'Thanks! We will email you when it is back.';
      msg.hidden = false;
    }).catch(function () {
      if (btn) btn.disabled = false;
      msg.textContent = 'Something went wrong. Please try again.';
      msg.hidden = false;
    });
  });

  /* ---------- Variant dropdown on cards ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gau-variant]');
    if (!sel) return;
    var card = sel.closest('.gau-card');
    var opt = sel.options[sel.selectedIndex];
    var idInput = card.querySelector('input[name="id"]');
    if (idInput) idInput.value = sel.value;
    var price = card.querySelector('[data-gau-price]');
    var compare = card.querySelector('[data-gau-compare]');
    var save = card.querySelector('[data-gau-save]');
    var badge = card.querySelector('[data-gau-badge]');
    if (price) price.textContent = opt.getAttribute('data-price') || '';
    if (compare) {
      var c = opt.getAttribute('data-compare');
      compare.textContent = c || '';
      compare.hidden = !c;
    }
    if (save) {
      var sv = opt.getAttribute('data-save');
      save.textContent = sv ? 'Save ' + sv : '';
      save.hidden = !sv;
    }
    if (badge) {
      var d = opt.getAttribute('data-discount');
      badge.textContent = d ? d + '% ' + (badge.getAttribute('data-suffix') || 'OFF') : '';
      badge.hidden = !d;
    }
    var btn = card.querySelector('.gau-atc__btn');
    if (btn) btn.disabled = opt.getAttribute('data-available') !== 'true';
  });
})();